import React, { useState, useEffect } from "react";
import useApi from "storybook-dashboard/utils/fetching";
import { ErrorBoundary } from "storybook-dashboard/errors";
import { BasicSpinner } from "storybook-dashboard/spinners/basicSpinner"
import IssuesRAGPanel from "storybook-dashboard/dashboard/ragPanels/issues";
import IndicatorsRAGPanel, { orderIndicators } from "storybook-dashboard/dashboard/ragPanels/indicators";
import IndicatorsBarChart from "storybook-dashboard/dashboard/charts/verticalBar";
import InputValuesTable from "storybook-dashboard/dashboard/project/inputValues";
import IndicatorPerformanceTable from "storybook-dashboard/dashboard/performanceTable";
import DataExplorer from "storybook-dashboard/dashboard/components/dataExplorer";
import DashboardFilters from "storybook-dashboard/dashboard/reportFilters";
import Moment from "moment"
import { Hider } from "storybook-dashboard/utils";

import { yearFilters } from "../project/dashboard";
import Im from "immutable";

const INDUSTRY_DASHBOARD_ID = "9d7c6f40";
const DEFAULT_PERIOD = "year";
export const DASHBOARD_YEAR = 2025;

// No longer used, but kept for possible reinstatement
export const lastYearFilters = () => {
  let key = "commit__reporting_period__endDate";
  let date = new Moment({ year: DASHBOARD_YEAR, month: 7, day: 1 });
  return Im.fromJS({
    [`${key}__gt`]: date.utc().startOf("year").toISOString(),
    [`${key}__lte`]: date.utc().add(1, "years").startOf("year").toISOString(),
  });
};

export default function DashboardComponents({ companyId, iconPath, indicatorOrder, downloadExcel }) {
  let [selectedIssue, setSelectedIssue] = useState(null);
  let [selectedIndicatorIds, setSelectedIndicatorIds] = useState(Im.Map());
  let [filters, setFilters] = useState(Im.Map());

  // Reset the selected indicators to none if the issue selection changes
  useEffect(() => {
    setSelectedIndicatorIds(Im.Map());
  }, [selectedIssue]);

  // Get the last period with a report submission
  let { data: latestReport, isLoading } = useApi("/api/dashboard/company/{companyId}/report/latest", {companyId})

  if (!latestReport || isLoading) { return (<BasicSpinner />) }

  console.log("DashboardComponents got latest report", companyId, latestReport?.toJS())

  let latestReportYear = (new Moment(latestReport?.get("startDate"))).year()
  let thisYearFilters = filters.merge(yearFilters(latestReportYear))

  // Get a list of only the selected indicators
  let selectedIndicators = orderIndicators(selectedIndicatorIds.toList(), indicatorOrder);

  return (
    <ErrorBoundary>
      <p>Latest reporting year: <b>{latestReportYear}</b></p>

      <div className="row">
        <ErrorBoundary>
          <DashboardFilters companyId={companyId} onApply={(values) => setFilters(values)} appliedFilters={filters} />
        </ErrorBoundary>
      </div>

      <ErrorBoundary>
        <IssuesRAGPanel
          companyId={companyId}
          iconPath={iconPath}
          selected={selectedIssue}
          setSelected={setSelectedIssue}
          filters={thisYearFilters}
          noRagColor={true}
          showNulls={true}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <IndicatorsRAGPanel
          companyId={companyId}
          iconPath={iconPath}
          issue={selectedIssue}
          indicatorOrder={indicatorOrder}
          selected={selectedIndicatorIds}
          setSelected={setSelectedIndicatorIds}
          filters={thisYearFilters}
          noRagColor={true}
          showNulls={true}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <IndicatorsBarChart
          companyId={companyId}
          indicators={selectedIndicators}
          downloadExcel={downloadExcel}
          filters={filters}
          period={DEFAULT_PERIOD}
          targetLabels={{ target: "ONS UK population", threshold: "Industry Benchmark" }}
        />
      </ErrorBoundary>

      <ErrorBoundary>
        <Hider hide={companyId?.startsWith(INDUSTRY_DASHBOARD_ID)}>
          <DataExplorer
            companyId={companyId}
            indicators={selectedIndicators}
            filters={filters}
            options={{
              metric_values: {
                text: "Performance breakdown table",
                component: IndicatorPerformanceTable,
              },
              performance: {
                text: "Input values table",
                component: InputValuesTable,
              },
            }}
          />
        </Hider>
      </ErrorBoundary>
    </ErrorBoundary>
  );
}
